export const FETCH_USER_ORGANIZATIONS_STATS = 'FETCH_USER_ORGANIZATIONS_STATS'
export const UPDATE_USER_ORGANIZATIONS = 'UPDATE_USER_ORGANIZATIONS'
export const GET_USER_ORGANIZATIONS = 'GET_USER_ORGANIZATIONS'
export const SET_LOADING = 'SET_LOADING'
export const GET_USER_ORGANIZATIONS_FAIL = 'GET_USER_ORGANIZATIONS_FAIL'
export const GET_USER_ORGANIZATIONS_STATS = 'GET_USER_ORGANIZATIONS_STATS'
